(() => {
  const ROOT_SELECTOR = '[data-hr-product-spirit-owned]';
  const PRODUCT_ANCHOR_ID = 'Shop Now';

  const OPTION_RIDS = [
    '2a0f368b-e7e7-486f-bb43-7e0674951384',
    'dd12a6ce-efcf-4fbb-a275-c124e47fb184',
    '7231efa6-993c-432a-a9fb-644e71770a3c'
  ];

  const SELECTED_OPTION_CLASSES = {
    '2a0f368b-e7e7-486f-bb43-7e0674951384': 'r-5ws2c6',
    'dd12a6ce-efcf-4fbb-a275-c124e47fb184': 'r-1krp12d',
    '7231efa6-993c-432a-a9fb-644e71770a3c': 'r-19lc2p3'
  };

  const PURCHASE_RIDS = {
    subscription: '75860ce6-f8ad-43ca-80ac-36c71a01714a',
    oneTime: 'e5cfdf7f-2ee9-4e6c-9bd1-bf7a762b895b'
  };

  const PRICE_RIDS = {
    subscription: 'f1678341-5951-4c9c-a844-d5ed3e546589',
    oneTime: 'd2172abd-bf21-40a7-828d-dc5dfe185b1f'
  };

  const BENEFIT_RIDS = {
    freeShippingRow: 'f118fafd-fb0b-441a-a88c-5cd1f96bbb4a',
    saveForever: 'fd23274c-55ca-43bb-b0e8-3d83b6c3f127'
  };

  const SUBSCRIPTION_UNIT_RIDS = [
    '45a7e424-6412-4969-b5bd-c07a2554e4bd',
    'd739ea71-2276-4b82-8b03-c260d08cf416',
    'a65a998b-d308-4834-91b8-b7c774ab47f5'
  ];

  const SUBSCRIPTION_UNIT_SELECTED_CLASSES = [
    'r-kfycpr',
    'r-l92pgf',
    'r-az14hv'
  ];

  const ONE_TIME_UNIT_RIDS = [
    'e7098bc2-0f2b-4ec7-9776-0f7c0b9b0bf1',
    '61ce3312-1081-4987-84b8-c97554d8db21',
    '6d48f101-168c-4cfe-9a03-7766a1473d17'
  ];

  const ONE_TIME_UNIT_SELECTED_CLASSES = [
    'r-100e5co',
    'r-1reg3e',
    'r-1r8jynl'
  ];

  const ATC_RID = '6ad4fe03-cc09-4555-8676-83c73109ebdf';
  const ATC_LABEL_RID = '3840ef9c-38a4-4bfe-b42b-00a0e5671730';
  const SOLD_OUT_RID = '36121624-4181-4f14-b2c2-33af44e28028';

  const parseConfig = (root) => {
    const node = root.querySelector('[data-hr-product-spirit-config]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('High Rider: invalid Spirit product configuration.', error);
      return null;
    }
  };

  const byRid = (root, rid) => root.querySelector(`[data-rid="${rid}"]`);
  const allByRid = (root, rid) => [...root.querySelectorAll(`[data-rid="${rid}"]`)];

  const textTarget = (element, allowElement = true) => {
    if (!element) return null;
    return element.querySelector('p') || element.querySelector(':scope > span') || (allowElement ? element : null);
  };

  const setText = (root, rid, value) => {
    allByRid(root, rid).forEach((element) => {
      const target = textTarget(element);
      if (target) target.textContent = value;
    });
  };

  const bindKeyboardActivation = (element, activate) => {
    if (!element || element.matches('button, a[href], input, select, textarea')) return;
    element.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      activate();
    });
  };

  const formatMoney = (cents, format = '${{amount}}') => {
    const value = Number(cents || 0);
    const withDelimiter = (number, precision, thousands, decimal) => {
      const fixed = (number / 100).toFixed(precision);
      const [whole, fraction] = fixed.split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fraction ? `${grouped}${decimal}${fraction}` : grouped;
    };
    const placeholder = format.match(/\{\{\s*(amount(?:_no_decimals)?(?:_with_comma_separator|_with_space_separator)?)\s*\}\}/)?.[1];
    if (!placeholder) return `$${withDelimiter(value, 2, ',', '.')}`;

    const replacements = {
      amount: withDelimiter(value, 2, ',', '.'),
      amount_no_decimals: withDelimiter(value, 0, ',', '.'),
      amount_with_comma_separator: withDelimiter(value, 2, '.', ','),
      amount_no_decimals_with_comma_separator: withDelimiter(value, 0, '.', ','),
      amount_with_space_separator: withDelimiter(value, 2, ' ', ','),
      amount_no_decimals_with_space_separator: withDelimiter(value, 0, ' ', ',')
    };
    return format.replace(/\{\{\s*[^}]+\s*\}\}/, replacements[placeholder] || replacements.amount);
  };

  const initializeCarousel = (root, gallery) => {
    const carousel = root.querySelector('[data-replo-carousel="true"]');
    if (!carousel || !gallery?.length) return;

    const tracks = [...carousel.querySelectorAll('[data-replo-part="slide-track"]')];
    const mainTrack = tracks.find((track) => track.dataset.reploRootId?.includes('R2fmsj2')) || tracks[0];
    const thumbnailTrack = tracks.find((track) => track !== mainTrack);
    const mainTemplate = mainTrack?.querySelector('[data-replo-part="slide"]');
    const thumbnailTemplate = thumbnailTrack?.querySelector('[data-replo-part="slide"]');
    const thumbnailViewport = thumbnailTrack?.parentElement?.parentElement || thumbnailTrack?.parentElement;
    if (!mainTrack || !mainTemplate) return;
    thumbnailViewport?.classList.add('hr-product-spirit-thumbnail-scroll');

    const makeSlide = (template, media, index, thumbnail = false) => {
      const slide = template.cloneNode(true);
      const url = thumbnail ? (media.thumbnailUrl || media.url) : media.url;
      slide.dataset.slideIndex = String(index);
      slide.dataset.slideSourceIndex = String(index);
      slide.dataset.isActive = String(index === 0);
      slide.dataset.hrProductSpiritGeneratedSlide = 'true';
      slide.removeAttribute('data-is-cloned');
      slide.id = `hr-product-spirit-${thumbnail ? 'thumbnail' : 'slide'}-${index}`;
      slide.setAttribute('aria-label', `Slide ${index + 1} of ${gallery.length}`);
      slide.setAttribute('aria-hidden', String(!thumbnail && index !== 0));
      slide.tabIndex = thumbnail ? 0 : (index === 0 ? 0 : -1);

      slide.querySelectorAll('source').forEach((source) => { source.srcset = url; });
      slide.querySelectorAll('img').forEach((image) => {
        image.src = url;
        image.removeAttribute('srcset');
        image.alt = media.alt || '';
        image.loading = index === 0 ? 'eager' : 'lazy';
      });

      if (thumbnail) {
        slide.setAttribute('role', 'button');
        slide.setAttribute('aria-label', `Show product image ${index + 1}`);
      }
      return slide;
    };

    const mainSlides = gallery.map((media, index) => makeSlide(mainTemplate, media, index));
    mainTrack.replaceChildren(...mainSlides);

    const thumbnailSlides = thumbnailTemplate && thumbnailTrack
      ? gallery.map((media, index) => makeSlide(thumbnailTemplate, media, index, true))
      : [];
    if (thumbnailTrack) thumbnailTrack.replaceChildren(...thumbnailSlides);

    const status = carousel.querySelector('[aria-live="polite"]');
    const previous = carousel.querySelector('[data-direction="previous"]');
    const next = carousel.querySelector('[data-direction="next"]');
    let activeIndex = 0;
    let touchStartX = null;

    const setActive = (nextIndex, animate = true) => {
      activeIndex = (nextIndex + mainSlides.length) % mainSlides.length;
      mainSlides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.dataset.isActive = String(active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.tabIndex = active ? 0 : -1;
      });

      mainTrack.style.transitionDuration = animate ? '320ms' : '0ms';
      mainTrack.style.transitionProperty = 'transform';
      mainTrack.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;

      thumbnailSlides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.dataset.isActive = String(active);
        slide.setAttribute('aria-current', active ? 'true' : 'false');
        slide.querySelector('[data-rid="b537262a-4890-4ec1-b033-849d49351851"]')
          ?.classList.toggle('r-75i3zk', active);
      });

      const activeThumbnail = thumbnailSlides[activeIndex];
      if (activeThumbnail && thumbnailViewport) {
        const maximum = Math.max(0, thumbnailViewport.scrollWidth - thumbnailViewport.clientWidth);
        const centered = activeThumbnail.offsetLeft
          - (thumbnailViewport.clientWidth - activeThumbnail.offsetWidth) / 2;
        thumbnailViewport.scrollTo({
          left: Math.max(0, Math.min(maximum, centered)),
          behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
        });
      }

      if (status) status.textContent = `Slide ${activeIndex + 1} of ${mainSlides.length}`;
      previous?.toggleAttribute('disabled', mainSlides.length < 2);
      next?.toggleAttribute('disabled', mainSlides.length < 2);
    };

    previous?.addEventListener('click', () => setActive(activeIndex - 1));
    next?.addEventListener('click', () => setActive(activeIndex + 1));
    thumbnailSlides.forEach((slide, index) => {
      slide.addEventListener('click', () => setActive(index));
      slide.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setActive(index);
      });
    });

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') setActive(activeIndex - 1);
      if (event.key === 'ArrowRight') setActive(activeIndex + 1);
    });
    carousel.addEventListener('touchstart', (event) => {
      if (thumbnailViewport?.contains(event.target)) {
        touchStartX = null;
        return;
      }
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });
    carousel.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) >= 40) setActive(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    setActive(0, false);
  };

  const initializeCollapsibles = (root) => {
    root.querySelectorAll('[data-replo-collapsible]').forEach((collapsible) => {
      if (collapsible.dataset.hrProductSpiritBound === 'true') return;
      const trigger = collapsible.querySelector(':scope > [role="button"][aria-controls]');
      const content = trigger ? document.getElementById(trigger.getAttribute('aria-controls')) : null;
      if (!trigger || !content || !root.contains(content)) return;
      collapsible.dataset.hrProductSpiritBound = 'true';

      const setOpen = (open) => {
        collapsible.dataset.state = open ? 'open' : 'closed';
        trigger.dataset.state = open ? 'open' : 'closed';
        trigger.setAttribute('aria-expanded', String(open));
        content.hidden = !open;
      };
      const toggle = () => setOpen(trigger.getAttribute('aria-expanded') !== 'true');

      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      });
      setOpen(trigger.getAttribute('aria-expanded') === 'true' && !content.hidden);
    });
  };

  const initializeLinks = (root, config) => {
    const productLinks = {
      'ee49601e-2c3e-4487-a8a1-6203cbc68195': config.routes.orbit,
      'f5d3dc28-61b4-4f8a-8e49-1e4d46a3fc14': config.routes.rush,
      'f4797c4b-1f4b-44e9-9fdf-08638a7b318f': config.routes.vibe
    };

    Object.entries(productLinks).forEach(([rid, href]) => {
      const element = byRid(root, rid);
      if (!element || !href) return;
      if (element.matches('a')) {
        element.href = href;
        element.removeAttribute('role');
      } else {
        element.setAttribute('role', 'link');
        const activate = () => { window.location.href = href; };
        element.addEventListener('click', activate);
        bindKeyboardActivation(element, activate);
      }
    });

    [
      '4e651873-42dc-43a2-af67-470a183badf6',
      'd9da8b83-a91d-400e-b19c-7c45e7ab76ec',
      '2057a196-30e6-4630-9d97-45b8c8227f8c'
    ].forEach((rid) => {
      const element = byRid(root, rid);
      const activate = () => {
        document.getElementById(PRODUCT_ANCHOR_ID)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      element?.addEventListener('click', activate);
      bindKeyboardActivation(element, activate);
    });

    const backToTop = byRid(root, '6f08ea99-b3b8-42e2-a165-2458789a3ba9');
    const returnToTop = () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    backToTop?.addEventListener('click', returnToTop);
    bindKeyboardActivation(backToTop, returnToTop);

    root.querySelectorAll('.jdgm-preview-badge').forEach((badge) => {
      badge.setAttribute('role', 'link');
      badge.tabIndex = 0;
      const activate = () => document.getElementById('judgeme_product_reviews')
        ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      badge.addEventListener('click', activate);
      badge.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activate();
      });
    });
  };

  const initializeProductForm = (root, config) => {
    const variants = config.variants || [];
    const optionNodes = OPTION_RIDS.map((rid) => byRid(root, rid)).filter(Boolean);
    const subscribeCard = byRid(root, PURCHASE_RIDS.subscription);
    const oneTimeCard = byRid(root, PURCHASE_RIDS.oneTime);
    const atcButton = byRid(root, ATC_RID);
    const soldOutNotice = byRid(root, SOLD_OUT_RID);
    const sourceForm = root.querySelector('form[action*="/cart/add"]');
    const variantInput = sourceForm?.querySelector('[name="id"]');
    const quantityInput = sourceForm?.querySelector('[name="quantity"]');
    const sellingPlanInput = sourceForm?.querySelector('[name="selling_plan"]');
    let sellingPlanSelect = root.querySelector('[data-hr-product-spirit-selling-plan]');
    const errorNode = root.querySelector('[data-hr-product-spirit-error]');
    if (!variants.length || !optionNodes.length || !atcButton || !variantInput) return;

    if (!sellingPlanSelect && subscribeCard) {
      sellingPlanSelect = document.createElement('select');
      sellingPlanSelect.dataset.hrProductSpiritSellingPlan = 'true';
      sellingPlanSelect.className = 'hr-product-spirit-selling-plan';
      sellingPlanSelect.setAttribute('aria-label', 'Delivery frequency');
      subscribeCard.appendChild(sellingPlanSelect);
    }

    const requestedVariantId = Number(new URL(window.location.href).searchParams.get('variant'));
    let selectedIndex = Math.max(0, variants.findIndex((variant) => (
      variant.id === requestedVariantId || (!requestedVariantId && variant.id === config.defaultVariantId)
    )));
    let purchaseMode = variants[selectedIndex]?.sellingPlans?.length ? 'subscription' : 'one-time';
    let selectedPlanId = variants[selectedIndex]?.sellingPlans?.[0]?.id || null;
    let loading = false;

    const currentVariant = () => variants[selectedIndex] || variants[0];
    const currentPlan = () => currentVariant().sellingPlans?.find((plan) => plan.id === Number(selectedPlanId))
      || currentVariant().sellingPlans?.[0]
      || null;

    const syncPlanSelect = () => {
      if (!sellingPlanSelect) return;
      const plans = currentVariant().sellingPlans || [];
      sellingPlanSelect.replaceChildren(...plans.map((plan) => {
        const option = document.createElement('option');
        option.value = String(plan.id);
        option.textContent = plan.name;
        option.selected = plan.id === Number(selectedPlanId);
        return option;
      }));
      sellingPlanSelect.disabled = purchaseMode !== 'subscription' || !plans.length;
    };

    const setElementText = (element, value) => {
      const target = textTarget(element, false);
      if (target) target.textContent = value;
    };

    const updateUnitPrices = (variant, plan) => {
      SUBSCRIPTION_UNIT_RIDS.forEach((rid, index) => {
        allByRid(root, rid).forEach((element) => {
          element.hidden = true;
          element.classList.remove(SUBSCRIPTION_UNIT_SELECTED_CLASSES[index]);
        });
      });
      ONE_TIME_UNIT_RIDS.forEach((rid, index) => {
        allByRid(root, rid).forEach((element) => {
          element.hidden = true;
          element.classList.remove(ONE_TIME_UNIT_SELECTED_CLASSES[index]);
        });
      });
      const bundleSize = Math.max(1, Number(variant.bundleSize || 1));
      const subscriptionUnits = allByRid(root, SUBSCRIPTION_UNIT_RIDS[selectedIndex]);
      const oneTimeUnits = allByRid(root, ONE_TIME_UNIT_RIDS[selectedIndex]);
      if (plan) {
        subscriptionUnits.forEach((element) => {
          setElementText(element, `${Math.round(plan.price / (bundleSize * 1250))}¢ per mg`);
          element.classList.add(SUBSCRIPTION_UNIT_SELECTED_CLASSES[selectedIndex]);
          element.hidden = false;
        });
      }
      oneTimeUnits.forEach((element) => {
        setElementText(element, `${formatMoney(Math.round(variant.price / bundleSize), config.moneyFormat)} ea.`);
        element.classList.add(ONE_TIME_UNIT_SELECTED_CLASSES[selectedIndex]);
        element.hidden = false;
      });
    };

    const updatePurchaseCards = (variant) => {
      const hasPlans = Boolean(variant.sellingPlans?.length);
      if (!hasPlans) purchaseMode = 'one-time';
      subscribeCard?.classList.toggle('r-rgvxh3', purchaseMode === 'subscription');
      if (subscribeCard) subscribeCard.dataset.hrSelected = String(purchaseMode === 'subscription');
      if (oneTimeCard) oneTimeCard.dataset.hrSelected = String(purchaseMode === 'one-time');
      subscribeCard?.setAttribute('aria-pressed', String(purchaseMode === 'subscription'));
      oneTimeCard?.setAttribute('aria-pressed', String(purchaseMode === 'one-time'));
      subscribeCard?.setAttribute('aria-disabled', String(!hasPlans));
      root.querySelectorAll(`input[type="radio"][value^="${PURCHASE_RIDS.subscription}."]`)
        .forEach((radio) => { radio.checked = purchaseMode === 'subscription'; });
      root.querySelectorAll(`input[type="radio"][value^="${PURCHASE_RIDS.oneTime}."]`)
        .forEach((radio) => { radio.checked = purchaseMode === 'one-time'; });
    };

    const updateBenefits = (variant) => {
      const bundleSize = Math.max(1, Number(variant.bundleSize || 1));
      allByRid(root, BENEFIT_RIDS.freeShippingRow).forEach((row) => {
        row.hidden = bundleSize === 1;
      });
      setText(root, BENEFIT_RIDS.saveForever, 'Save 20% forever');
    };

    const render = () => {
      const variant = currentVariant();
      if (!variant) return;
      if (!variant.sellingPlans?.some((plan) => plan.id === Number(selectedPlanId))) {
        selectedPlanId = variant.sellingPlans?.[0]?.id || null;
      }
      const plan = currentPlan();
      variantInput.value = String(variant.id);
      if (quantityInput) quantityInput.value = quantityInput.value || '1';
      if (sellingPlanInput) sellingPlanInput.value = purchaseMode === 'subscription' && plan ? String(plan.id) : '';

      optionNodes.forEach((option, index) => {
        const selected = index === selectedIndex;
        option.setAttribute('aria-selected', String(selected));
        option.setAttribute('aria-label', `${variants[index]?.title || `Option ${index + 1}`}${variants[index]?.available ? '' : ', sold out'}`);
        option.dataset.hrAvailable = String(Boolean(variants[index]?.available));
        option.tabIndex = selected ? 0 : -1;
        option.classList.toggle(SELECTED_OPTION_CLASSES[option.dataset.rid], selected);
      });

      updatePurchaseCards(variant);
      syncPlanSelect();
      setText(root, PRICE_RIDS.subscription, formatMoney(plan?.price || variant.price, config.moneyFormat));
      setText(root, PRICE_RIDS.oneTime, formatMoney(variant.price, config.moneyFormat));
      updateUnitPrices(variant, plan);
      updateBenefits(variant);

      const purchasable = variant.available && !loading;
      atcButton.disabled = !purchasable;
      atcButton.setAttribute('aria-disabled', String(!purchasable));
      setText(root, ATC_LABEL_RID, variant.available ? config.addToCartLabel : config.soldOutLabel);
      if (soldOutNotice) soldOutNotice.hidden = variant.available;
    };

    const selectVariant = (index, updateUrl = true) => {
      if (!variants[index]) return;
      selectedIndex = index;
      selectedPlanId = variants[index].sellingPlans?.[0]?.id || null;
      render();
      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variants[index].id));
        window.history.replaceState({}, '', url);
      }
    };

    optionNodes.forEach((option, index) => {
      option.addEventListener('click', () => selectVariant(index));
      option.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectVariant(index);
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          optionNodes[(index + 1) % optionNodes.length].focus();
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          optionNodes[(index + optionNodes.length - 1) % optionNodes.length].focus();
        }
      });
    });

    const selectSubscription = () => {
      if (!currentVariant().sellingPlans?.length) return;
      purchaseMode = 'subscription';
      selectedPlanId ||= currentVariant().sellingPlans[0].id;
      render();
    };
    const selectOneTime = () => {
      purchaseMode = 'one-time';
      render();
    };
    subscribeCard?.addEventListener('click', selectSubscription);
    oneTimeCard?.addEventListener('click', selectOneTime);
    bindKeyboardActivation(subscribeCard, selectSubscription);
    bindKeyboardActivation(oneTimeCard, selectOneTime);
    sellingPlanSelect?.addEventListener('change', () => {
      selectedPlanId = Number(sellingPlanSelect.value);
      render();
    });

    const setLoading = (nextLoading) => {
      loading = nextLoading;
      let indicator = atcButton.querySelector('.hr-product-spirit-loading');
      if (!indicator) {
        indicator = document.createElement('span');
        indicator.className = 'hr-product-spirit-loading';
        indicator.setAttribute('aria-hidden', 'true');
        indicator.innerHTML = '<span>LOADING</span><span class="hr-product-spirit-spinner"></span>';
        atcButton.appendChild(indicator);
      }
      atcButton.dataset.hrLoading = String(nextLoading);
      atcButton.setAttribute('aria-busy', String(nextLoading));
      render();
    };

    const openCart = async (state) => {
      for (let attempt = 0; attempt < 600; attempt += 1) {
        if (typeof window.EliteCart?.openDrawerWithDataRefresh === 'function') {
          await window.EliteCart.openDrawerWithDataRefresh();
          return true;
        }
        await new Promise((resolve) => window.setTimeout(resolve, 100));
      }

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer?.renderContents && state.sections) {
        cartDrawer.renderContents(state);
        return true;
      }
      return false;
    };

    const addToCart = async () => {
      const variant = currentVariant();
      const plan = currentPlan();
      if (loading || !variant?.available) return;
      if (errorNode) errorNode.hidden = true;
      setLoading(true);

      const formData = new FormData();
      formData.append('id', String(variant.id));
      formData.append('quantity', quantityInput?.value || '1');
      if (purchaseMode === 'subscription' && plan) formData.append('selling_plan', String(plan.id));
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', `${window.location.pathname}${window.location.search}`);

      try {
        const response = await fetch(config.routes.cartAdd || '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add this item.');

        document.dispatchEvent(new CustomEvent('high-rider:cart-added', {
          detail: { productId: config.productId, variantId: variant.id, cartData: state }
        }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'hr-product-spirit-owned', cartData: state, variantId: variant.id
          });
        }

        if (!await openCart(state)) window.location.assign(config.routes.cart || '/cart');
      } catch (error) {
        console.error('High Rider: Spirit add to cart failed.', error);
        if (errorNode) {
          errorNode.textContent = error?.message || 'Unable to add this item. Please try again.';
          errorNode.hidden = false;
          atcButton.insertAdjacentElement('afterend', errorNode);
        }
      } finally {
        setLoading(false);
      }
    };

    atcButton.addEventListener('click', (event) => {
      event.preventDefault();
      addToCart();
    });
    sourceForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      addToCart();
    });

    selectVariant(selectedIndex, false);
  };

  const initialize = (root) => {
    if (root.dataset.hrProductSpiritInitialized === 'true') return;
    const config = parseConfig(root);
    if (!config) return;
    root.dataset.hrProductSpiritInitialized = 'true';

    initializeCarousel(root, config.gallery);
    initializeCollapsibles(root);
    initializeLinks(root, config);
    if (!root.querySelector('[data-hr-spirit-bundle-buybox]')) {
      initializeProductForm(root, config);
    }
    window.jdgm?.initializeWidgets?.();
  };

  const initializeAll = (container = document) => {
    if (container.matches?.(ROOT_SELECTOR)) initialize(container);
    container.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
